import type { DateTime } from 'luxon';
import type { ReactNode } from 'react';
import { useI18nContext } from '@/i18n/i18n-react';
import { useTenant } from '@/hooks/use-tenant';
import { greetingFor, homeEyebrow } from '@/lib/home-greeting';

export interface HomeHeaderProps {
  now: DateTime;
  /** The `PeriodFilter`: right of the title from 768px, below it on mobile. */
  periodFilter: ReactNode;
}

/**
 * Top of the Início (HOME-01): the blue eyebrow with the date and the
 * greeting with the store name. No analytics text in the title.
 */
export function HomeHeader({ now, periodFilter }: HomeHeaderProps) {
  const { LL, locale } = useI18nContext();
  const tenant = useTenant();

  return (
    <header className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between md:gap-6">
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#155DFC]">
          {homeEyebrow(now, locale, LL)}
        </p>
        <h1 className="text-3xl font-medium leading-tight tracking-[-0.035em] md:text-[40px]">
          {`${greetingFor(now, LL)}, ${tenant.name}.`}
        </h1>
      </div>
      <div className="min-w-0 md:shrink-0">{periodFilter}</div>
    </header>
  );
}
